import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

/**
 * Réponse de génération d'activité avec IA
 */
export class GenerateActivityResponseDto {
  @ApiProperty({
    description: "Contenu généré de l'activité",
    type: 'object',
    additionalProperties: true,
  })
  content!: any

  @ApiProperty({
    description: "Configuration générée de l'activité",
    type: 'object',
    additionalProperties: true,
  })
  config!: any

  @ApiPropertyOptional({
    description: 'Solution générée (si applicable)',
    type: 'object',
    additionalProperties: true,
  })
  solution?: any
}
